export const FAQTableDefaultEng = {
  Consultants: [
    {
      question:
        "How can I become an affiliated consultant with American Fidelity Global Solutions Ltd? ",
      answer:
        "Please contact us at <a href='mailto:Health-Sales@americanfidelity.com'>Health-Sales@americanfidelity.com</a> or call us at <tel>+1786 235-9302</tel>to receive more details. ",
    },
    {
      question:
        "Does American Fidelity Global Solutions Ltd. provide training for new consultants?",
      answer:
        "Our sales team has a program in place to onboard our new consultants. Please contact us for more details.",
    },
    {
      question:
        "Which markets will the American Fidelity Global Solutions Ltd. be commercialized? ",
      answer:
        "Our health products will be available for clients residing in Latin America and the Caribbean.",
    },
  ],
  "Our Plans": [
    {
      question:
        "What is the benefit of purchasing an American Fidelity Global Solutions Ltd. plan when I already have a local insurance policy?",
      answer:
        "Our plans offer worldwide coverage, allowing clients to get treatment anywhere in the world. They may also include several benefits to assist you with your health needs.<br>We offer three comprehensive global health insurance plans with various deductible options and network selections in the U.S.:<ul><li>AF Health Superior</li><li>AF Health Optima</li><li>AF Health Vital</li></ul>",
    },
    {
      question:
        "What is the difference between American Fidelity Global Solutions Ltd. plans?",
      answer:
        "All our plans include international healthcare services and extensive global coverage. The coverage limits and benefits vary depending on the plan. For more details, access the plans’ summary on our website.",
    },
    {
      question:
        "What makes American Fidelity Global Solutions Ltd. stands out from other health insurance?",
      answer:
        "With advanced technology to offer global coverage, 24/7 service, comprehensive benefits, support and preventive health programs, Reward Program, and Care Programs. American Fidelity Global Solutions Ltd. helps ensure a modern and intuitive experience.",
    },
    {
      question:
        "How does American Fidelity Global Solutions Ltd. use technology to improve the customer experience?",
      answer:
        "The American Fidelity Global Solutions Ltd. integrates technological solutions to streamline processes such as quoting and issuing policies, filing or tracking claims, and virtual services such as telemedicine, second medical opinion, and mental health coaching, offering everyone a simple and improved experience.",
    },
    {
      question:
        "Is American Fidelity Global Solutions Ltd. supported with insurance experience and financial strength?",
      answer:
        "American Fidelity Global Solutions Ltd. is part of the Cameron Group of Companies that has more than 60 years of insurance experience.",
    },
    {
      question:
        "How has the Cameron Group of Companies, proven its status in the insurance industry?",
      answer:
        "American Fidelity Assurance Company, an affiliate of American Fidelity Global Solutions Ltd. within the Cameron Group of Companies, has achieved the rating of “A+” (Superior) by AM Best Company, a recognition American Fidelity Assurance Company has earned since 1982. This award represents a commitment to reliability and stability. Considered one of the nation’s leading insurance company rating services, AM Best bases its ratings on an analysis of the financial condition and operating performance of a company (Rating June 7, 2024, A+ is the 2nd highest out of 16 with 1 being the highest).",
    },
  ],
  Underwriting: [
    {
      question:
        "How can I apply for a health insurance policy with American Fidelity Global Solutions Ltd.?",
      answer:
        "All applications must be submitted by a consultant via our consultant portal. Please contact our Customer Care Service for more details at customercare@americanfidelity.com.",
    },
    {
      question:
        "If I have a medical condition, may I apply for a plan with American Fidelity Global Solutions Ltd.?",
      answer:
        "Yes, you may. Our Underwriting Department will evaluate all declared medical conditions to determine coverage.",
    },
    {
      question:
        "How do I know the non-insurable conditions before applying for a policy with American Fidelity Global Solutions Ltd.?",
      answer:
        "Insurability questions should be sent to our Underwriting team at MedicalUnderwriting@americanfidelity.com. You will receive a response shortly after.",
    },
    {
      question:
        "What is the age eligibility to purchase a policy with American Fidelity Global Solutions Ltd.?",
      answer:
        "At the time of the application, the Applicant must be between 18 and 76 years old.",
    },
    {
      question: "May I include my family in my health insurance plan?",
      answer:
        "Yes. All health plans offered by American Fidelity Global Solutions Ltd. are either individual or family plans. ",
    },
    {
      question:
        "Who qualifies as a dependent on my policy with American Fidelity Global Solutions Ltd.?",
      answer:
        "Eligible dependents are spouses, domestic partners, biological children, legally adopted children, stepchildren, or minor children for whom the Policyholder has been appointed legal guardian by a court of competent jurisdiction.",
    },
    {
      question:
        "Can a dependent over 18 years old be under the family policy with American Fidelity Global Solutions Ltd.?",
      answer:
        "An unmarried dependent child enrolled as a full-time student at an accredited college may continue their coverage until the Renewal Date following their 24th birthday. ",
    },
  ],
  "Policy Administration": [
    {
      question: "What is the review period for the acceptance of my policy?",
      answer:
        "The Policyholder has the right to review the policy and notify American Fidelity Global Solutions Ltd.  within 10 days of receiving it if he/she is not satisfied with the coverage offered. The notification can be made directly to American Fidelity Global Solutions Ltd. or through the consultant.",
    },
    {
      question:
        "May I change plans, network or deductible after applying for a policy with American Fidelity Global Solutions Ltd.?",
      answer:
        "Yes. You can modify or adjust your coverage on your policy anniversary. You may also be eligible to upgrade your hospital network in the U.S. without modifying your current plan by completing the NetMore form available in the portal.",
    },
    {
      question:
        "May I register more than one email address with my American Fidelity Global Solutions Ltd. account?",
      answer:
        "Both Policyholder and Spouse can register their email address and have their own login credential to access the portal.",
    },
  ],
  "Premium Payment": [
    {
      question:
        "What are the premium payment options offered with my American Fidelity Global Solutions Ltd. policy?",
      answer:
        "Premiums can be paid annually, semi-annually, quarterly, or monthly. A payment mode frequency change can only be made on the Policy’s Anniversary Date.",
    },
    {
      question:
        "When must I submit the premium payment for my new policy with American Fidelity Global Solutions Ltd.?",
      answer:
        "The premium should be submitted along with the policy application for immediate activation upon policy approval. <br />You may pay your premium by accessing the portal and clicking the payment icon.",
    },
  ],
  "Policy Documents": [
    {
      question: "How may I access my ID card or Policy Documents?",
      answer:
        "You may access ID cards or Policy Documents by logging into the American Fidelity Global Solutions Ltd. portal under the Policy Documents section or contacting our Customer Care team at <a href='mailto:customercare@americanfidelity.com'>customercare@americanfidelity.com</a> or <tel>+1786-235-9302</tel>.",
    },
  ],
  "Clinical Care": [
    {
      question: "How may I notify a medical event, and what is the timeframe?",
      answer:
        "Contact us at least seventy-two (72) hours before receiving any medical service for which notification is required. You must notify all emergencies within forty-eight (48) hours after the event.<br>You can notify us by WhatsApp at  <tel>+405-318-9347</tel>,by calling at <tel>+1786-235-9302</tel>, toll-free at <tel>+1800-232-1317</tel>, or sending an email to <a href='mailto:clinicalcare@americanfidelity.com'>clinicalcare@americanfidelity.com</a>.",
    },
    {
      question:
        "Which procedures do I have to request Pre-Authorization from American Fidelity Global Solutions Ltd.?",
      answer:
        "<ul><li>All maternities and deliveries.</li><li>Reconstructive surgery.</li><li>Durable medical home equipment or special devices.</li><li>All hospital admissions, including intensive care.</li><li>All inpatient or outpatient surgery.</li><li>Major diagnostic tests such as MRI, CT, endoscopies, colonoscopies, and biopsies.</li><li>Emergency transportation by air ambulance.</li><li>Ambulatory physical therapy, rehabilitation, and home health care.</li><li>Repatriation of mortal remains.</li><li>Palliative care in case of a terminal condition.</li><li>Organ and tissue transplants.</li><li>HIV/AIDS.</li><li>Prophylactic surgery to reduce cancer risk.</li><li>Bariatric surgery, gastric bypass, and any surgical procedure for weight loss, complications, or treatments.</li><li>Cancer treatment.</li><li>Fertility treatment.</li><li>Kidney dialysis.</li><li>Prosthetics.</li><li>Specialized treatment.</li><li>Refractive surgery.</li></ul>",
    },
    {
      question:
        "May I access specialized treatments with American Fidelity Global Solutions Ltd. health insurance plans?",
      answer:
        "Yes. Our plans offer coverage for specialized treatments that are Medically Necessary (as defined in the policy) related to occupational therapies, speech therapies, kinesiology, autism (for dependent insureds who develop the condition while covered under the policy), sleep apnea or other sleep disorders, psychiatry, or psychology. For more details and specific coverage, please refer to the Conditions of Coverage.",
    },
  ],
  "Traveling to the U.S.": [
    {
      question:
        "How may I find an Urgent Care or Convenience Clinic if I travel to the United States?",
      answer:
        "Access the link: <a href='https://www.whyuhc.com/us2'>https://www.whyuhc.com/us2</a><br>Under the Choice Plus Plan, select Search the Network Choice Plus, click on Search the Network Choice Plus, and follow the prompts based on your search.",
    },
    {
      question: "How may I find a Pharmacy if I travel to the United States?",
      answer:
        "Access the link: <a href='https://www.whyuhc.com/us2'>https://www.whyuhc.com/us2</a><br>Under Prescription Benefits, select Search for Network Pharmacy, click on Find the Network Pharmacy, and follow the prompts based on your search.",
    },
  ],
  Portals: [
    {
      question: "How can I access the portals?",
      answer:
        "Once you are approved as a consultant or as an Insured, we will send a notification to the registered email address with the company so you can complete the registration process. To register, you may access the portals by clicking on the top right links of the American Fidelity Global Solutions Ltd. website, where we have the client portal and consultant portal options.",
    },
    {
      question:
        "How can I contact American Fidelity Global Solutions Ltd. Customer Care team?",
      answer:
        "For any inquiries or support, please contact our Customer Care team at <a href='mailto:customercare@americanfidelity.com'>customercare@americanfidelity.com</a> or <tel>+1786-235-9302</tel>. ",
    },
  ],
};

export const FAQTableDefaultSpanish = {
  Consultores: [
    {
      question:
        "¿Cómo puedo convertirme en consultor afiliado de American Fidelity Global Solutions Ltd.?",
      answer:
        "Por favor, contáctenos enviando un mensaje para <a href='mailto:Health-Sales@americanfidelity.com'>Health-Sales@americanfidelity.com</a> o llámenos al <tel>+1786 235-9302</tel> para recibir más detalles.",
    },
    {
      question:
        "¿American Fidelity Global Solutions Ltd. ofrece capacitación para nuevos consultores?",
      answer:
        "Nuestro equipo de ventas tiene un programa establecido para incorporar a nuestros nuevos consultores. Por favor, contáctenos para más detalles.",
    },
    {
      question:
        "¿En qué mercados se comercializará American Fidelity Global Solutions Ltd.?",
      answer:
        "Nuestros productos de salud estarán disponibles para clientes que residen en América Latina y el Caribe.",
    },
  ],
  "Nuestros Planes": [
    {
      question:
        "¿Cuál es el beneficio de adquirir un plan de American Fidelity Global Solutions Ltd. si ya tengo una póliza de seguro local?",
      answer:
        "Nuestros planes ofrecen cobertura mundial, permitiendo a los clientes recibir tratamiento en cualquier parte del mundo. También pueden incluir varios beneficios para ayudarle con sus necesidades de cobertura de salud.",
    },
    {
      question:
        "¿Cuál es la diferencia entre los planes de American Fidelity Global Solutions Ltd.?",
      answer:
        "Todos nuestros planes incluyen servicios de atención médica internacional y una amplia cobertura global. Los límites de cobertura y los beneficios varían según el plan. Para obtener más detalles, acceda al resumen de los planes en nuestro sitio web",
    },
    {
      question:
        "¿Qué hace que American Fidelity Global Solutions Ltd. se destaque de otros seguros de salud?",
      answer:
        "Con tecnología avanzada para ofrecer cobertura global, servicio 24/7, beneficios integrales, programas de apoyo y salud preventiva, Programa de Recompensas y Programas de Cuidados Médicos. American Fidelity Global Solutions Ltd. ayuda a garantizar una experiencia moderna e intuitiva.",
    },
    {
      question:
        "¿Cómo utiliza American Fidelity Global Solutions Ltd. la tecnología para mejorar la experiencia del cliente?",
      answer:
        "American Fidelity Global Solutions Ltd. integra soluciones tecnológicas para optimizar procesos como la cotización y emisión de pólizas, la presentación o el seguimiento de reclamaciones, y servicios virtuales como la telemedicina, la segunda opinión médica y el coaching de salud mental, ofreciendo a todos una experiencia sencilla y mejorada.",
    },
    {
      question:
        "¿American Fidelity Global Solutions Ltd. está respaldada por experiencia en seguros y solidez financiera?",
      answer:
        "American Fidelity Global Solutions Ltd. forma parte del Grupo de Empresas Cameron, que cuenta con más de 60 años de experiencia en seguros.",
    },
    {
      question:
        "¿Cómo ha demostrado el Grupo de Empresas Cameron su estatus en la industria de seguros?",
      answer:
        'American Fidelity Assurance Company, una filial de American Fidelity Global Solutions Ltd. dentro del Grupo de Empresas Cameron, ha logrado la calificación de "A+" (Superior) de AM Best Company, un reconocimiento que American Fidelity Assurance Company ha obtenido desde 1982. Esta calificación representa un compromiso con la confiabilidad y la estabilidad. Considerado uno de los servicios de calificación de compañías de seguros líderes del país, AM Best basa sus calificaciones en un análisis de la condición financiera y el desempeño operativo de una compañía.',
    },
  ],
  "Evaluación De Riesgo": [
    {
      question:
        "¿Cómo puedo solicitar una póliza de seguro de salud con American Fidelity Global Solutions Ltd.?",
      answer:
        "Todas las solicitudes deben ser presentadas por un consultor a través de nuestro portal de consultores. Por favor, contacte a nuestro Servicio de Atención al Cliente para más detalles en <a href='mailto:customercare@americanfidelity.com'>customercare@americanfidelity.com</a>.",
    },
    {
      question:
        "¿Si tengo una condición médica, puedo solicitar un plan con American Fidelity Global Solutions Ltd.?",
      answer:
        "Sí, puede hacerlo. Nuestro Departamento de Suscripción evaluará todas las condiciones médicas declaradas para determinar la cobertura.",
    },
    {
      question:
        "¿Cómo puedo saber cuales son las condiciones no asegurables antes de solicitar una póliza con American Fidelity Global Solutions Ltd.?",
      answer:
        "Las preguntas sobre asegurabilidad deben enviarse a nuestro equipo de Suscripción a <a href='mailto:MedicalUnderwriting@americanfidelity.com'>MedicalUnderwriting@americanfidelity.com</a>. Recibirá una respuesta en breve.",
    },
    {
      question:
        "¿Cuál es la edad mínima para contratar una póliza con American Fidelity Global Solutions Ltd.?",
      answer:
        "En el momento de la solicitud, el solicitante debe tener entre 18 y 76 años.",
    },
    {
      question: "¿Puedo incluir a mi familia en mi plan de seguro de salud?",
      answer:
        "Sí. Todos los planes de salud ofrecidos por American Fidelity Global Solutions Ltd. son planes individuales o familiares.",
    },
    {
      question:
        "¿Quién califica como dependiente en mi póliza con American Fidelity Global Solutions Ltd.?",
      answer:
        "Los dependientes elegibles son cónyuges, parejas domésticas, hijos biológicos, hijos legalmente adoptados, hijastros o hijos menores para quienes el Titular de la Póliza ha sido nombrado tutor legal por un tribunal de jurisdicción competente.",
    },
    {
      question:
        "¿Puede un dependiente mayor de 18 años estar bajo la póliza familiar con American Fidelity Global Solutions Ltd.?",
      answer:
        "Un hijo dependiente soltero matriculado como estudiante a tiempo completo en una universidad acreditada puede continuar su cobertura hasta la fecha de renovación siguiente a su 24º cumpleaños.",
    },
  ],
  "Administración De Pólizas": [
    {
      question:
        "¿Cuál es el período de revisión para la aceptación de mi póliza?",
      answer:
        "El Titular de la Póliza tiene derecho a revisar la póliza y notificar a American Fidelity Global Solutions Ltd. dentro de los 10 días siguientes a su recepción si no está satisfecho con la cobertura ofrecida. La notificación se puede realizar directamente a American Fidelity Global Solutions Ltd. o a través del consultor.",
    },
    {
      question:
        "¿Puedo cambiar de planes, red o deducible después de solicitar una póliza con American Fidelity Global Solutions Ltd.?",
      answer:
        "Sí. Puede modificar o ajustar su cobertura en el aniversario de su póliza. También puede ser elegible para actualizar su red hospitalaria en los EE. UU. sin modificar su plan actual completando el formulario NetMore disponible en el portal.",
    },
    {
      question:
        "¿Puedo registrar más de una dirección de correo electrónico en mi cuenta de American Fidelity Global Solutions Ltd.?",
      answer:
        "Tanto el Titular de la Póliza como el Cónyuge pueden registrar su dirección de correo electrónico y tener sus propias credenciales de inicio de sesión para acceder al portal.",
    },
  ],
  "Pago De La Prima": [
    {
      question:
        "¿Cuáles son las opciones de pago de primas que ofrece mi póliza de American Fidelity Global Solutions Ltd.?",
      answer:
        "Las primas se pueden pagar anualmente, semestralmente, trimestralmente o mensualmente. Un cambio en la frecuencia del modo de pago solo se puede realizar en la fecha de aniversario de la póliza.",
    },
    {
      question:
        "¿Cuándo debo realizar el pago de la prima de mi nueva póliza con American Fidelity Global Solutions Ltd.?",
      answer:
        "La prima debe presentarse junto con la solicitud de la póliza para su activación inmediata una vez aprobada la póliza. Puede pagar su prima accediendo al portal y haciendo clic en el icono de pago.",
    },
  ],
  "Documentos De La Póliza": [
    {
      question:
        "¿Cómo puedo acceder a mi tarjeta de identificación o a los documentos de la póliza?",
      answer:
        "Puede acceder a las tarjetas de identificación o a los documentos de la póliza iniciando sesión en el portal de American Fidelity Global Solutions Ltd. en la sección de Documentos de la Póliza o contactando a nuestro equipo de Atención al Cliente en <a href='mailto:customercare@americanfidelity.com'>customercare@americanfidelity.com</a> o al <tel>+1786-235-9302</tel>.",
    },
  ],
  "Atención Clínica": [
    {
      question: "¿Cómo puedo notificar un evento médico, y cuál es el plazo?",
      answer:
        "Contáctenos al menos setenta y dos (72) horas antes de recibir cualquier servicio médico para el cual se requiera notificación. Debe informar todas las emergencias dentro de las cuarenta y ocho (48) horas posteriores al evento. Puede notificarnos por WhatsApp al +405-318-9347, llamando al +1786-235-9302, sin costo al +1800-232-1317, o enviando un correo electrónico a <a href='mailto:clinicalcare@americanfidelity.com'>clinicalcare@americanfidelity.com</a>.",
    },
    {
      question:
        "¿Para qué procedimientos debo solicitar Autorización Previa de American Fidelity Global Solutions Ltd.?",
      answer:
        "Todas las maternidades y partos, Cirugía reconstructiva, Equipos médicos duraderos en el hogar o dispositivos especiales, Todas las admisiones hospitalarias incluidas la atención intensiva, Todas las cirugías ambulatorias o de hospitalización, Pruebas de diagnóstico mayores como MRI, CT, endoscopias, colonoscopias y biopsias, Transporte de emergencia por ambulancia aérea, Fisioterapia ambulatoria y atención de salud en el hogar, Repatriación de restos mortales, Cuidados paliativos en caso de una condición terminal, Trasplante de órganos y tejidos, VIH/SIDA, Cirugía profiláctica para reducir el riesgo de cáncer, Cirugía bariátrica bypass gástrico y cualquier procedimiento quirúrgico para complicaciones o tratamientos de pérdida de peso, Tratamiento contra el cáncer, Tratamiento de fertilidad, Diálisis renal, Prótesis, Tratamiento especializado, Cirugía refractiva.",
    },
    {
      question:
        "¿Puedo acceder a tratamientos especializados con los planes de seguro médico de American Fidelity Global Solutions Ltd.?",
      answer:
        "Sí. Nuestros planes ofrecen cobertura para tratamientos especializados que sean Médicamente Necesarios (según se define en la póliza) relacionados con terapias ocupacionales, terapias del habla, kinesiología, autismo (para asegurados dependientes que desarrollan la condición mientras están cubiertos por la póliza), apnea del sueño u otros trastornos del sueño, psiquiatría o psicología. Para más detalles y cobertura específica, consulte las Condiciones de Cobertura.",
    },
  ],
  "Viajar A Ee.Uu.": [
    {
      question:
        "¿Cómo puedo encontrar una Clínica de Atención Urgente o de Conveniencia si viajo a los Estados Unidos?",
      answer:
        "Acceda al enlace: https://www.whyuhc.com/us2 En el Plan Choice Plus, seleccione Buscar en la Red Choice Plus, haga clic en Buscar en la Red Choice Plus y siga las indicaciones según su búsqueda.",
    },
    {
      question:
        "¿Cómo puedo encontrar una farmacia si viajo a los Estados Unidos?",
      answer:
        "Acceda al enlace: https://www.whyuhc.com/us2 Bajo Beneficios de Recetas, seleccione Buscar Farmacia de la Red, haga clic en Encontrar la Farmacia de la Red y siga las indicaciones según su búsqueda.",
    },
  ],
  Portales: [
    {
      question: "¿Cómo puedo acceder a los portales?",
      answer:
        "Una vez aprobado como consultor o como Asegurado, enviaremos una notificación al correo electrónico registrado con la empresa para que pueda completar el proceso de registro. Para registrarse, puede acceder a los portales haciendo clic en los enlaces de la parte superior derecha del sitio web de American Fidelity Global Solutions Ltd., donde tenemos las opciones de portal de cliente y portal de consultor.",
    },
    {
      question:
        "¿Cómo puedo contactar al equipo de Atención al Cliente de American Fidelity Global Solutions Ltd.?",
      answer:
        "Para cualquier consulta o soporte, contacte a nuestro equipo de Atención al Cliente en <a href='mailto:customercare@americanfidelity.com'>customercare@americanfidelity.com</a> o <tel>+1786-235-9302</tel>.",
    },
  ],
};
